import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext } from 'react';
import { Settings } from '@mui/icons-material';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { DeviceState } from 'console/shared/contexts/device/state/types';
import { ResponsiveIcon } from '../../icon/responsive';
import { Button, IconButton } from '@mui/material';
import { DeviceConfig } from 'console/shared/contexts/device/config/types';
import { selectNullableSelectedDeviceId } from 'entities/device/lib';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { useOpenDeviceSettings } from 'features/device.settings.open/lib';
import branding from 'shared/app/model/branding';
export const GoToSettings = memo(function GoToSettings(props) {
    const { objectId, groupKey, itemKey, label = 'Перейти в настройки', onClick, full, ...rest } = props;
    const { device_id } = useDeviceConfig();
    const selectedDeviceId = useAppSelector(selectNullableSelectedDeviceId);
    const { is_service_mode } = useContext(DeviceState);
    const { is_climatic } = useContext(DeviceConfig);
    const { is_legacy_device } = useContext(DeviceConfig);
    const [show_settings_button, onOpenDeviceSettings] = useOpenDeviceSettings(device_id);
    const openSettings = useCallback((event) => {
        event.stopPropagation();
        onClick?.();
        onOpenDeviceSettings(event, groupKey, itemKey, objectId);
    }, [groupKey, itemKey, objectId, onClick, device_id]);
    if (branding.code == 'baxi') {
        return null;
    }
    if (!is_service_mode || (!selectedDeviceId && !device_id)) {
        return null;
    }
    if (is_climatic) {
        return null;
    }
    if (is_legacy_device) {
        return null;
    }
    if (!show_settings_button) {
        return null;
    }
    return full ? (_jsx(Button, { color: "neutral", fullWidth: true, onClick: openSettings, startIcon: _jsx(ResponsiveIcon, { Icon: Settings, fontSize: "0.9em" }), ...rest, children: label })) : (_jsx(IconButton, { color: "inherit", sx: {
            fontSize: '0.9em',
            padding: 0,
        }, onClick: openSettings, ...rest, children: _jsx(ResponsiveIcon, { color: "inherit", Icon: Settings, fontSize: "0.9em" }) }));
});
